import styled from "styled-components";

export const PlaceholderPage = styled.main`
  min-height: 100dvh;
  display: grid;
  place-items: center;
  box-sizing: border-box;
  padding: 120px ${({ theme }) => theme.padding.regular}
    ${({ theme }) => theme.padding.regular};
`;

export const PlaceholderCard = styled.article`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.regular};
  width: min(100%, 720px);
  box-sizing: border-box;
  padding: ${({ theme }) => theme.padding.large};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background: ${({ theme }) => theme.colors.lightBlue};
  color: ${({ theme }) => theme.colors.darkBlue};

  span {
    font-size: ${({ theme }) => theme.typography.regular.fontSize};
    font-weight: ${({ theme }) => theme.fontWeight.semibold};
    text-transform: uppercase;
  }

  h1,
  p {
    margin: 0;
  }

  h1 {
    font-size: ${({ theme }) => theme.typography.h1.fontSize};
    line-height: 1.1;
    text-transform: uppercase;
  }

  p {
    line-height: 1.5;
  }

  @media (max-width: 520px) {
    padding: ${({ theme }) => theme.padding.regular};

    h1 {
      font-size: ${({ theme }) => theme.typography.h2.fontSize};
    }

    p {
      font-size: ${({ theme }) => theme.typography.medium.fontSize};
    }
  }
`;

export const BackLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.small};
  width: fit-content;
  padding: 12px 18px;
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.greyBlue};
  color: ${({ theme }) => theme.colors.offWhite};
  font-size: ${({ theme }) => theme.typography.medium.fontSize};
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.25s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.accent};
  }
`;
